import {ChangeDetectionStrategy, Component, computed, inject, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {map, Observable, tap} from 'rxjs';

import {HttpLoaderService, LoadResult} from 'shared/services';
import {ListUi} from '../list-ui/list-ui';
import {Params} from '@angular/router';
import {TournamentModel} from 'shared/models';

export interface DataShape {
  tournaments: {list: TournamentModel[]};
  // call2Data: {param1: number, param3: number};
}

// Parametros de las llamadas
interface ApiParams {
  tournaments: {tournamentId: number};
  // call2Data: {fooId: number, httpParams?: HttpParams};
}

@Component({
  // selector: 'lib-tournaments',
  standalone: true,
  imports: [CommonModule, MatProgressSpinner, ListUi],
  templateUrl: './list.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class List {
  // private loader: LoadResult<DataShape, ApiParams>;
  //
  // protected hasAttemptedLoad: Signal<boolean>;
  // protected isLoading: Signal<boolean>;
  // protected error: Signal<string | null>;
  // protected data1: Signal<DataShape['call1Data'] | null>;
  // protected data2: Signal<DataShape['call2Data'] | null>;
  //
  // constructor(
  //   private http: HttpClient,
  //   private loaderService: HttpLoaderService,
  // ) {
  //   this.loader = this.loaderService.createLoader<DataShape, ApiParams>({
  //     call1Data: (params: ApiParams['call1Data']): Observable<any> => {
  //       return this.http.get('https://jsonplaceholder.typicode.com/todos/1');
  //     },
  //     call2Data: (params: ApiParams['call2Data']): Observable<any> => {
  //       return this.http.get('https://jsonplaceholder.typicode.com/posts/1');
  //     },
  //   });
  //
  //   // Deriva los signals individuales
  //   this.hasAttemptedLoad = this.loader.hasAttemptedLoad;
  //   this.isLoading = this.loader.isLoading;
  //   this.error = this.loader.error;
  //   this.data1 = computed((): DataShape['call1Data'] | null => this.loader.data()?.call1Data ?? null);
  //   this.data2 = computed((): DataShape['call2Data'] | null => this.loader.data()?.call2Data ?? null);
  //
  //   // Opcional: Cargar datos iniciales al construir el componente
  //   this.loadData(1, 1);
  // }

  private http: HttpClient = inject(HttpClient);
  private loaderService: HttpLoaderService = inject(HttpLoaderService);

  private loader: LoadResult<DataShape, ApiParams> = this.loaderService.createLoader<DataShape, ApiParams>({
    tournaments: (params: ApiParams['tournaments']): Observable<DataShape['tournaments']> => {
      console.info('tournaments params', params);
      return this.http.get('tournaments').pipe(
        map((data: Params): DataShape['tournaments'] => {
          const list: TournamentModel[] = data['data'].map((item: Params): TournamentModel => {
            return TournamentModel.getInstance(item);
          });

          // const paginator: Paginator = {
          //   total: data.total,
          //   perPage: data.perPage,
          //   currentPage: data.currentPage,
          //   lastPage: data.lastPage,
          //   // from: data.from,
          //   // to: data.to
          // };

          // return {list, paginator};
          return {list};
        })
      );
    },
    // call2Data: (params: ApiParams['call2Data']): Observable<any> => {
    //   console.info('call2Data params', params);
    //   return this.http.get('https://jsonplaceholder.typicode.com/posts/1');
    // },
  });

  protected hasAttemptedLoad: Signal<boolean> = this.loader.hasAttemptedLoad;
  protected isLoading: Signal<boolean> = this.loader.isLoading;
  protected error: Signal<string | null> = this.loader.error;
  // Deriva los signals individuales
  protected tournaments: Signal<DataShape['tournaments'] | undefined> = computed((): DataShape['tournaments'] | undefined => {
    return this.loader.data()?.tournaments;
  });
  // protected data2: Signal<DataShape['call2Data'] | null> = computed((): DataShape['call2Data'] | null => {
  //   return this.loader.data()?.call2Data ?? null;
  // });

  constructor() {
    // Opcional: Cargar datos iniciales al construir el componente
    this.loadData(1, 2);
  }

  loadData(tournamentId: number, fooId: number): void {
    const params: ApiParams = {
      tournaments: {tournamentId},
      // call2Data: {
      //   fooId,
      //   httpParams: new HttpParams({
      //     fromObject: {
      //       param1: 3,
      //       param2: 4,
      //     },
      //   }),
      // },
    };
    this.loader.trigger(params);
  }
}
